import { AppData } from "../../AppDataProvider";
import { CompleteOrganisationStepPayload } from "../../actions";
import { Mixpanel } from "../../../mixpanel";

export type CompleteOrganisationStepOpts = {
  appData: AppData;
  payload: CompleteOrganisationStepPayload;
};

export const completeOrganisationStep = (
  options: CompleteOrganisationStepOpts,
): AppData => {
  const { steps, bookingData } = options.appData;

  const nextStepIndex = steps.findIndex((step) => step === "services");

  const { organisation } = options.payload.updatedData;

  Mixpanel.track({
    name: "Completed step",
    props: {
      selectedOrganisation: {
        id: organisation._id,
        name: organisation.name,
        slug: organisation.slug,
      },
      step: "organisations",
    },
  });

  const updatedBookingData = {
    ...bookingData,
    ...options.payload.updatedData,
    ...(organisation.forceTimezone !== "AUTO_DETECT" && {
      timezone: organisation.forceTimezone,
    }),
  };

  return {
    ...options.appData,
    bookingData: updatedBookingData,
    currentStep: steps[nextStepIndex],
  };
};
